module.exports = __webpack_public_path__ + "img/24.6f74ebe6.png";